import Component from '@glimmer/component';
import formatDateString from '../../../helpers/format-date-string.ts';
import safeFormatDate from '../../../helpers/safe-format-date.ts';
import { LinkTo } from '@ember/routing';
import { service } from '@ember/service';
import { task } from 'ember-concurrency';
import { tracked } from '@glimmer/tracking';
import type Store from '@ember-data/store';
import type GenericRelationshipModel from '../../../models/generic-relationship.ts';
import type Owner from '@ember/owner';
import type EmployeeModel from '../../../models/employee.ts';

interface ProfileRoleDelegationRowSignature {
  Args: {
    delegate: Partial<GenericRelationshipModel>;
    cellClass: string;
    employeeRoute?: string;
  };
  Element: HTMLElement;
}

export default class ProfileRoleDelegationRowComponent extends Component<ProfileRoleDelegationRowSignature> {
  @service declare store: Store;
  @tracked isLoading = true;

  @tracked employeeFullName: string = '';

  loadEmployeeData = task(async () => {
    const governorId = this.args.delegate.governorId;
    if (!governorId) {
      // TODO: this seems like it should never happen
      this.isLoading = false;
      return;
    }
    const employee = await this.store.findRecord<EmployeeModel>('employee', governorId);
    this.employeeFullName = employee.fullName || '';
    this.isLoading = false;
  });

  constructor(owner: Owner, args: ProfileRoleDelegationRowSignature['Args']) {
    super(owner, args);
    this.loadEmployeeData.perform();
  }

  get expirationDate() {
    return this.args.delegate.expiresAfter ? this.args.delegate.expiresAfter : 'N/A';
  }

  <template>
    {{#if this.loadEmployeeData.isRunning}}
      <tr>
        <td class={{@cellClass}} colspan="100">
          <div class="h-4 bg-gray-200 rounded-full"></div>
        </td>
      </tr>
    {{else}}
      <tr>
        <td class={{@cellClass}}>
          {{#if @employeeRoute}}
            <LinkTo
              @route={{@employeeRoute}}
              @model={{@delegate.governorId}}
            >{{this.employeeFullName}}</LinkTo>
          {{else}}
            {{this.employeeFullName}}
          {{/if}}
        </td>
        <td class={{@cellClass}}>{{@delegate.relationshipType}}</td>
        <td class={{@cellClass}}>{{safeFormatDate
            @delegate.createdAt
            month="2-digit"
            day="2-digit"
            year="numeric"
          }}</td>
        <td class={{@cellClass}}>{{if @delegate.isActive "ACTIVE" "INACTIVE"}}</td>
        <td class={{@cellClass}}>{{formatDateString this.expirationDate}}</td>
      </tr>
    {{/if}}
  </template>
}
